import React from "react";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useGetBusinessTrendsQuery } from "../../../../redux/service/modules/sales";
import { InteractionChart } from "./InteractionChart";
import { useSelector } from "react-redux";

export const BusinessTrends = ({ appliedFilters, setRequiredFilters }) => {
    const dateRange = useSelector((state) => state.date);
    return (
        <div>
            <PaginatedDataTable
                queryHook={useGetBusinessTrendsQuery}
                initialDateRange={dateRange}
                isColumnSticky={true}
                stickyColumnsCount={1}
                appliedFilters={appliedFilters}
            />
            <div>
                <InteractionChart />
            </div>
        </div>
    );
};
